import { useEffect, useRef, useState } from 'react'

type Props = {
  requestFn(): Promise<any>
  requestKey?: any
}

export function useRequest<T>({ requestFn, requestKey = '' }: Props) {
  const [loading, setLoading] = useState<boolean>(false)
  const [data, setData] = useState<T>()
  const [error, setError] = useState<any>()

  const cachedKey = useRef<string>()
  const [key, setKey] = useState<any>(() => requestKey)

  useEffect(() => {
    setKey(requestKey)
  }, [requestKey])

  useEffect(() => {
    if (key === cachedKey.current) return
    cachedKey.current = key

    setLoading(() => true)

    requestFn()
      .then((d) => {
        setData(d)
      })
      .catch((e) => {
        setError(e)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [requestFn, key])

  return { loading, data, error }
}
